<template>
  <div class="stage-item">
    <div class="title">
      {{ $ml.get(data['StageName']) }}
    </div>
    <table class="th-table">
      <tr class="head">
        <td class="left">
          {{ $ml.get(section['lang']['grade']) }}
        </td>
        <td class="left">
          {{ $ml.get(section['lang']['weight']) }}
        </td>
        <td class="left">
          {{ $ml.get(section['lang']['composition']) }}
        </td>
        <td>
          {{ $ml.get(section['lang']['apply']) }}
        </td>
        <td>
          {{ $ml.get(section['lang']['loads']) }}
        </td>
      </tr>

      <tr>
        <td class="left">
          {{ $ml.get(data['LoadName']) }}
        </td>
        <td class="left">
          {{ parseFloat($store.getters['unit/convert']('kg', data['LoadWeight'])).toFixed(1) }} {{$ml.get($store.getters['unit/getLabel']('kg'))}}
        </td>
        <td class="left">
          <div v-for="fert in data['Fertilizers']">
            {{ $ml.get(fert['Name']) }} - {{ $store.getters['unit/convert']('kg', Math.round(fert['Concentration'], 3))  }} {{$ml.get($store.getters['unit/getLabel']('kg'))}}
          </div>
        </td>
        <td>
          {{ parseFloat($store.getters['unit/convert']('kg', Math.round(data['BlendToApply'], 3))).toFixed(1) }} {{$ml.get($store.getters['unit/getLabel']('kg'))}}
        </td>
        <td>
          {{ Math.round(data['BlendToApply'] / data['LoadWeight'], 3) }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: {},
  },

  computed: {
    section() {
      return this.$root.data.blend
    }
  },
}
</script>

<style lang="scss" scoped>

.stage-item {

  page-break-inside: avoid;
  
  .title {
    font-weight: bold;
    font-size: 15px;
    text-align: left;
    padding: 10px 0;
  }
  
}

</style>